import React from "react";
import { SnackbarProvider as BaseUISnackbarProvider, SnackbarProviderProps } from "baseui/snackbar";
import { Theme } from "../../../../styling/baseui_theme";

export type SnackBarVariation = "default" | "success" | "danger";

const defaultStyleOverrides = {
  PlacementContainer: {
    style: {
      zIndex: 99999,
    },
  },
};

// moves the snackbar below the header bar
export const snackBarOverrides = {
  Root: {
    props: {
      "data-test": "snackbar",
    },
    style: ({ $theme }: { $theme: Theme }) => ({
      marginTop: $theme.sizing.scale1600,
    }),
  },
};

export const snackBarOverridesForVariation = (variation: SnackBarVariation) => ({
  Root: {
    props: {
      ...snackBarOverrides.Root.props,
    },
    style: ({ $theme }: { $theme: Theme }) => ({
      ...snackBarOverrides.Root.style({ $theme }),
      ...(variation === "success"
        ? {
            color: $theme.colors.contentPositive,
            backgroundColor: $theme.colors.backgroundPositiveLight,
          }
        : {}),
      ...(variation === "danger"
        ? {
            color: $theme.colors.contentNegative,
            backgroundColor: $theme.colors.backgroundPositiveLight,
          }
        : {}),
    }),
  },
});

export const SnackbarProvider = ({
  placement,
  defaultDuration,
  children,
}: SnackbarProviderProps) => (
  <BaseUISnackbarProvider
    placement={placement}
    defaultDuration={defaultDuration}
    overrides={defaultStyleOverrides}
  >
    {children}
  </BaseUISnackbarProvider>
);
